
export class DetailAnnulation {
    crFarisPercent: number;
    crFarisType: boolean;
    from: number;
    to: number;
    crHasMin: boolean | null = false;
    crMinValue: number | null;
    crMinType: number | null;
    public bindingData(data) {
        this.crFarisPercent = data.crFarisPercent;
        this.crFarisType = data.crFarisType;
        this.from = data.from;
        this.to = data.to ? data.to : -1;
        if (data.crHasMin != undefined && data.crHasMin && data.crMinValue != undefined && data.crMinType != undefined) {
            this.crHasMin = data.crHasMin;
            this.crMinValue = data.crMinValue;
            this.crMinType = data.crMinType;
        }
        return this;
    }

    isFierstNight(): string {
        if (this.crFarisType) {
            return '1erenuit'
        }
        return 'reservation'
    }

    hasMinFee(): boolean {
        return this.crHasMin;
    }

    clone(): DetailAnnulation {
        let d = new DetailAnnulation();
        d.bindingData(this);
        return d;
    }
}
